export const notifyError = (error: unknown) => {
  console.error(error)
}
